import { SearchBox } from "@fluentui/react";
import { computed } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { store } from "../../store";
import css from "./help-search.scss";

export interface HelpSidebarProps {}

@observer
export class HelpSearch extends React.Component<HelpSidebarProps> {
    @computed private get searchHint(): JSX.Element {
        const { isSearching, remainingSearchCharacters } = store.serviceHelp;
        if (!isSearching) {
            return <></>;
        }
        if (remainingSearchCharacters > 0) {
            return (
                <p className={css.helpSearch__hint}>
                    {store.i18n.t("helpSearch.queryTooShort", {
                        count: remainingSearchCharacters,
                    })}
                </p>
            );
        }

        const count = store.serviceHelp.searchResults?.articles.length ?? 0;
        return (
            <p className={css.helpSearch__hint}>
                {store.i18n.t("helpSearch.resultCount", { count })}
            </p>
        );
    }

    public render(): JSX.Element {
        return (
            <div className={css.helpSearch}>
                <SearchBox
                    placeholder={store.i18n.t("helpSearch.placeholder")}
                    onChange={(_, value?: string) => (store.serviceHelp.query = value ?? "")}
                    value={store.serviceHelp.query}
                    onClear={() => (store.serviceHelp.query = "")}
                />
                {this.searchHint}
            </div>
        );
    }
}
